import React from 'react';
import { Grid } from '@mui/material';
import { InputV2, EstadoInputV2, CidadeInputV2, WidgetV2, DatePickerV2 } from '../../../components/v2';

const InformacaoPessoalTab = ({ values, setValues, readOnly }) => {
  const handleChange = (event) => {
    setValues({ ...values, [event.target.name]: event.target.value });
  };

  const handlerEstado = (value) => {
    setValues({ ...values, estado: value, cidade: '' });
  };

  const handlerCidade = (value) => {
    setValues({ ...values, cidade: value });
  };

  return (
    <Grid container spacing={3}>
      <Grid size={{ xs: 4 }}>
        <InputV2
          label="RG"
          name="rg"
          onChange={handleChange}
          value={values.rg}
          disabled={readOnly}
        />
      </Grid>
      <Grid size={{ xs: 4 }}>
        <InputV2
          label="CPF"
          name="cpf"
          onChange={handleChange}
          value={values.cpf}
          disabled={readOnly}
        />
      </Grid>
      <Grid size={{ xs: 4 }}>
        <DatePickerV2
          label="Data de Nascimento"
          onChange={(data) => setValues({ ...values, dataNascimento: data })}
          value={values.dataNascimento}
          disabled={readOnly}
          showInput
        />
      </Grid>
      <Grid size={{ xs: 4 }}>
        <InputV2
          label="Matrícula CEMIG"
          name="matriculaCemig"
          onChange={handleChange}
          value={values.matriculaCemig}
          disabled={readOnly}
        />
      </Grid>
      <Grid size={{ xs: 4 }}>
        <InputV2
          label="CTPS"
          name="ctps"
          onChange={handleChange}
          value={values.ctps}
          disabled={readOnly}
        />
      </Grid>
      <Grid size={{ xs: 4 }}>
        <InputV2
          label="CTPS Serie"
          name="ctpsSerie"
          onChange={handleChange}
          value={values.ctpsSerie}
          disabled={readOnly}
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <WidgetV2 title="Endereço">
          <Grid container spacing={3} sx={{ p: 3 }}>
            <Grid size={{ xs: 6 }}>
              <InputV2
                label="Rua"
                name="rua"
                onChange={handleChange}
                value={values.rua}
                disabled={readOnly}
              />
            </Grid>
            <Grid size={{ xs: 2 }}>
              <InputV2
                label="Número"
                name="numero"
                onChange={handleChange}
                value={values.numero}
                disabled={readOnly}
              />
            </Grid>
            <Grid size={{ xs: 4 }}>
              <InputV2
                label="Complemento"
                name="complemento"
                onChange={handleChange}
                value={values.complemento}
                disabled={readOnly}
              />
            </Grid>
            <Grid size={{ xs: 3 }}>
              <InputV2
                label="Bairro"
                name="bairro"
                onChange={handleChange}
                value={values.bairro}
                disabled={readOnly}
              />
            </Grid>
            <Grid size={{ xs: 3 }}>
              <InputV2
                label="CEP"
                name="cep"
                onChange={handleChange}
                value={values.cep}
                disabled={readOnly}
              />
            </Grid>
            <Grid size={{ md: 3, xs: 12 }}>
              <EstadoInputV2
                estado={values.estado}
                onSelect={handlerEstado}
                disabled={readOnly}
              />
            </Grid>
            <Grid size={{ md: 3, xs: 12 }}>
              <CidadeInputV2
                cidade={values.cidade}
                estado={values.estado}
                onSelect={handlerCidade}
                disabled={readOnly}
              />
            </Grid>
          </Grid>
        </WidgetV2>
      </Grid>
    </Grid>
  );
};

export default InformacaoPessoalTab;
